import { ZodError } from 'zod';
import { captureException } from '@sentry/browser';

import { apiClient } from '@f/api-client';

import { createAction } from '../actions';

export const REACTION_SEARCH_PREFERENCE_FIND_START = 'REACTION_SEARCH_PREFERENCE_FIND_START';
export const REACTION_SEARCH_PREFERENCE_FIND_FULFILL = 'REACTION_SEARCH_PREFERENCE_FIND_FULFILL';
export const REACTION_SEARCH_PREFERENCE_FIND_REJECT = 'REACTION_SEARCH_PREFERENCE_FIND';

export const REACTION_SEARCH_PREFERENCE_PATCH_START = 'REACTION_SEARCH_PREFERENCE_PATCH_START';
export const REACTION_SEARCH_PREFERENCE_PATCH_FULFILL = 'REACTION_SEARCH_PREFERENCE_PATCH_FULFILL';
export const REACTION_SEARCH_PREFERENCE_PATCH_REJECT = 'REACTION_SEARCH_PREFERENCE_PATCH_REJECT';

export const REACTION_SEARCH_PREFERENCE_CREATE_START = 'REACTION_SEARCH_PREFERENCE_CREATE_START';
export const REACTION_SEARCH_PREFERENCE_CREATE_FULFILL = 'REACTION_SEARCH_PREFERENCE_CREATE_FULFILL';
export const REACTION_SEARCH_PREFERENCE_CREATE_REJECT = 'REACTION_SEARCH_PREFERENCE_CREATE_REJECT';

export const REACTION_SEARCH_PREFERENCE_REMOVE_START = 'REACTION_SEARCH_PREFERENCE_REMOVE_START';
export const REACTION_SEARCH_PREFERENCE_REMOVE_FULFILL = 'REACTION_SEARCH_PREFERENCE_REMOVE_FULFILL';
export const REACTION_SEARCH_PREFERENCE_REMOVE_REJECT = 'REACTION_SEARCH_PREFERENCE_REMOVE_REJECT';

export function findReactionSearchPreferences(forceRefresh = false) {
  return async (dispatch, getState) => {
    const state = getState();
    const findState = state.reactionSearchPreference.find;
    if (!forceRefresh && findState.initialized) {
      return;
    }

    dispatch(createAction(REACTION_SEARCH_PREFERENCE_FIND_START));

    try {
      const result = await apiClient.parameterPreset.fetchPresets();

      if (result.status !== 200) {
        throw new Error(result.body);
      }

      dispatch(createAction(REACTION_SEARCH_PREFERENCE_FIND_FULFILL, { result: result.body }));
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      dispatch(createAction(REACTION_SEARCH_PREFERENCE_FIND_REJECT, error));
    }
  };
}

export function patchReactionSearchPreferences(data) {
  return async dispatch => {
    dispatch(createAction(REACTION_SEARCH_PREFERENCE_PATCH_START));

    try {
      const result = await apiClient.parameterPreset.updatePreset({
        params: { id: data.id },
        body: data,
      });

      if (result.status !== 200) {
        throw new Error(result.body);
      }

      await dispatch(findReactionSearchPreferences(true));

      dispatch(createAction(REACTION_SEARCH_PREFERENCE_PATCH_FULFILL, { result: result.body }));
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      dispatch(createAction(REACTION_SEARCH_PREFERENCE_PATCH_REJECT, error));
    }
  };
}

export function createReactionSearchPreferences(data) {
  return async dispatch => {
    dispatch(createAction(REACTION_SEARCH_PREFERENCE_CREATE_START));

    try {
      const result = await apiClient.parameterPreset.createPreset({
        body: data,
      });

      if (result.status !== 201) {
        throw new Error(result.body);
      }

      await dispatch(findReactionSearchPreferences(true));

      dispatch(createAction(REACTION_SEARCH_PREFERENCE_CREATE_FULFILL, { result: result.body }));
      return result.id;
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      dispatch(createAction(REACTION_SEARCH_PREFERENCE_CREATE_REJECT, error));
    }
  };
}

export function removeReactionSearchPreferences(ids) {
  return async dispatch => {
    dispatch(createAction(REACTION_SEARCH_PREFERENCE_REMOVE_START));

    try {
      const result = await apiClient.parameterPreset.removePreset({
        body: ids,
      });

      if (result.status !== 200) {
        throw new Error(result.body);
      }

      await dispatch(findReactionSearchPreferences(true));

      dispatch(createAction(REACTION_SEARCH_PREFERENCE_REMOVE_FULFILL, { result: result.body }));
      return ids;
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      dispatch(createAction(REACTION_SEARCH_PREFERENCE_REMOVE_REJECT, error));
      return error;
    }
  };
}
